<template>
    <q-dialog :value="oneClickOrderModal"
              :maximized="$q.platform.is.mobile"
              @hide="close()"
              transition-show="scale"
              transition-hide="scale"
    >
        <q-card class="modal-one-click-order modal-40">
            <template v-if="order">
                <div class="modal-header">
                    <span class="modal-title">Ваш заказ №{{ order.order_id }} оформлен</span>
                    <div class="modal-close" @click="close">
                    <span aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                            <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                        </svg>
                    </span>
                    </div>
                    <div class="modal-title">
                        <span>В ближайшее время с вами свяжется наш менеджер для подтверждения заказа.</span>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="modal-header">
                    <span class="modal-title">Быстрая покупка</span>
                    <div class="modal-close" @click="close">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill="" d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content">
                    <div class="row py-3 city-name-container">
                        <div class="product-delivery-location col">
                            <span>Ваш город</span>
                            <span class="product-delivery-location-city" @click.prevent="$root.selectCity">
                                <svg width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.09937 0.821045C7.58068 0.821045 9.59937 2.93309 9.59937 5.52913C9.59937 8.7509 5.57231 13.4806 5.40085 13.6804C5.23981 13.8681 4.95863 13.8678 4.79788 13.6804C4.62642 13.4806 0.599365 8.7509 0.599365 5.52913C0.599414 2.93309 2.61808 0.821045 5.09937 0.821045ZM5.09937 7.8979C6.34778 7.8979 7.3634 6.83528 7.3634 5.52913C7.3634 4.22299 6.34775 3.16039 5.09937 3.16039C3.85098 3.16039 2.83535 4.22301 2.83535 5.52916C2.83535 6.8353 3.85098 7.8979 5.09937 7.8979Z" stroke="#24AAFF"/>
                                </svg>
                                <span>{{ $root.cityName }}</span>
                            </span>
                        </div>
                    </div>

                    <q-input
                        outlined
                        class="required"
                        v-model="name"
                        label="Ваше имя"
                        :error-message="getError('name')"
                        :error="hasError('name')" />

                    <q-input
                        outlined
                        :class="['required', { 'is-invalid': hasError('phone_number') }]"
                        name="phone_number"
                        id="phone_number"
                        mask="+7 (###) ###-##-##"
                        label="Ваш телефон"
                        @blur="onBlurPhoneNumber"
                        @focus="focusPhoneNumber"
                        :fill-mask="fillPhoneNumberMask"
                        v-model="phone_number"
                        @input="clearError('phone_number')"
                        :error="hasError('phone_number')"
                        :error-message="getError('phone_number')" />
                    <template v-if="!promoCodeApplied">
                        <q-input outlined
                                 class="promo-code"
                                 v-model="promoCodeForm.promo_code"
                                 label="Промокод"
                                 :error-message="promoCodeForm.errors.get('promo_code')"
                                 :error="promoCodeForm.errors.has('promo_code')"
                                 @keydown="promoCodeForm.errors.clear('promo_code')">
                            <template v-slot:after>
                                <q-btn label="Применить" @click.prevent="applyPromoCode"/>
                            </template>
                        </q-input>
                    </template>
                    <div class="promo-code-applied" v-else>
                        <span v-html="'Промокод <span class=\'text-weight-bold\'>' + promoCodeForm.promo_code + '</span> применён!'"></span>
                        <q-btn label="Удалить" @click.prevent="removePromoCode"/>
                    </div>
                    <div class="cart-total-items">
                        <div class="cart-total-item">
                            <span>Товаров в корзине:</span>
                            <span> </span>
                            <span>{{ activeItemsCount }}</span>
                        </div>
                        <div class="cart-total-item">
                            <span>Общая стоимость:</span>
                            <span></span>
                            <span>{{ $root.priceFormat(totalPriceWithoutDiscount) }} &#x20bd;</span>
                        </div>
                        <div v-if="totalDiscount" class="cart-total-item">
                            <span>Скидка К-С:</span>
                            <span></span>
                            <span> - {{ $root.priceFormat(totalDiscount) }} &#x20bd;</span>
                        </div>
                        <div v-if="clientCardDiscount" class="cart-total-item">
                            <span>Скидка по карте клиента:</span>
                            <span></span>
                            <span> - {{ $root.priceFormat(clientCardDiscount) }} &#x20bd;</span>
                        </div>
                        <div v-if="promoCode && promoCodeDiscount" class="cart-total-item">
                            <span>Скидка по промо коду {{ promoCode }}:</span>
                            <span></span>
                            <span> - {{ $root.priceFormat(promoCodeDiscount) }} &#x20bd;</span>
                        </div>
                        <div v-if="deliveryMethod" class="cart-total-item">
                            <span>Доставка ({{ deliveryMethod }})</span>
                            <span v-if="deliveryCost !== false"></span>
                            <span v-if="deliveryCost !== false">{{ deliveryCost ? deliveryCost + ' &#x20bd;' : 'Бесплатно' }}</span>
                        </div>
                        <div class="cart-total-item">
                            <span>ИТОГО К ОПЛАТЕ:</span>
                            <span></span>
                            <span>{{ $root.priceFormat(greatTotalPrice) }} &#x20bd;</span>
                        </div>
                    </div>

                    <q-btn @click.prevent="submitOrder" label="Оформить заказ" class="full-width" />

                    <div class="confirmation q-mt-md">
                        Нажимая на кнопку «Оформить заказ», вы принимаете условия <a href="javascript: void(0)" @click="$root.redirect('/offer/')" title="Публичная оферта">Публичной оферты</a>
                    </div>

                </q-card-section>
            </template>
        </q-card>
    </q-dialog>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
import phoneNumberMixin from './../../mixins/phone_number';
import promoCode from './../../mixins/promo_code';

export default {
    name: "OneClickOrder",
    mixins: [
        phoneNumberMixin,
        promoCode,
    ],
    data() {
        return {
            order: false,
            opened: false,
        }
    },
    watch: {
        oneClickOrderModal (val) {
            if (val && !this.opened) {
                this.opened = true;
                window.events.onOneClickOpen();
            }
        }
    },
    computed: {
        ...mapState('geo', ['location']),
        ...mapState('cart', ['form', 'errors', 'oneClickOrderModal', 'promoCode']),
        ...mapState('catalog', ['products']),
        ...mapState('product', ['details']),
        ...mapGetters({
            submittable: 'cart/submittable',
            hasError: 'cart/hasError',
            getError: 'cart/getError',
            activeItemsCount: 'cart/activeItemsCount',
            totalPriceWithoutDiscount: 'cart/totalPriceWithoutDiscount',
            totalDiscount: 'cart/totalDiscount',
            clientCardDiscount: 'cart/clientCardDiscount',
            promoCodeDiscount: 'cart/promoCodeDiscount',
            totalPrice: 'cart/totalPrice',
        }),
        ...mapGetters('asset', [
            'deliveryMethodName',
        ]),
        ...mapGetters('delivery', {
            getDeliveryCost: 'deliveryCost',
        }),
        greatTotalPrice () {
            return this.totalPrice + (this.deliveryCost ? this.deliveryCost : 0);
        },
        deliveryMethod () {
            let deliveryMethodId = this.$store.state.cart.form.delivery_method_id;

            return deliveryMethodId ? this.deliveryMethodName(deliveryMethodId) : '';
        },
        deliveryCost () {
            let _this = this;

            let deliveryMethodId = _this.$store.state.cart.form.delivery_method_id;
            let serviceId = _this.$store.state.cart.form.service_id;
            let regionId = _this.$store.state.cart.form.address.region.id;
            let cityId = _this.$store.state.cart.form.address.city.id;
            let paymentTypeId = _this.$store.state.cart.form.payment_type_id;

            if (_this.totalPrice < 3000) {
                paymentTypeId = 1;
            }

            return deliveryMethodId && serviceId && regionId && cityId && paymentTypeId
                ? _this.getDeliveryCost(deliveryMethodId, serviceId, regionId, cityId, paymentTypeId)
                : false;
        },
        accept: {
            get () {
                return this.$store.state.cart.form.accept === 1;
            },
            set (value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'accept',
                    value: value ? 1 : 0
                });
            }
        },
        promo_code() {
            return this.$store.state.cart.promoCode;
        },
        phone_number: {
            get () {
                return this.$store.state.cart.form.phone_number;
            },
            set (value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'phone_number',
                    value: value
                });
            }
        },
        name: {
            get () {
                return this.$store.state.cart.form.name;
            },
            set (value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'name',
                    value: value
                });
            }
        },
    },
    methods: {
        ...mapMutations({
            clearErrors: 'cart/clearErrors',
            clearError: 'cart/clearError',
            toggleOneClickOrderModal: 'cart/toggleOneClickOrderModal',
        }),
        ...mapActions('cart', ['checkCustomer', 'oneClickSubmit']),
        onBlurPhoneNumber () {
            this.blurPhoneNumber();
            this.checkCustomer();
        },
        getPhoneNumber () {
            return this.phone_number;
        },
        setPhoneNumberCallback () {
            this.phone_number = '';
        },
        submitOrder() {
            let _this = this;

            if (!this.submitting) {
                _this.$store.commit('cart/setFormValue', {
                    key: 'address',
                    value: _this.location
                });

                _this.$store.commit('cart/updateStatusSubmitting', true);
                _this.oneClickSubmit().then(response => {
                    _this.order = response.order;

                    if (_this.products.length) {
                        let products = _this.products;
                        products.forEach(function (product, index) {
                            if (product.id === response.product.id) {
                                products[index] = Object.assign(product, response.product);
                            }
                        });
                        _this.$store.commit('catalog/setProducts', products);
                    } else {
                        _this.$store.commit('product/setProductDetails', response.product);
                    }

                    _this.$store.commit('product/clearSelection');
                    _this.clearErrors();
                    window.events.onOneClickPurchased({
                        order:{id: _this.order.order_id, total: _this.order.total},
                        products: [{
                            id: response.product.id
                        }]
                    });
                });
            }
        },
        close() {
            this.toggleOneClickOrderModal(false);
            this.order = false;
            this.clearErrors();
        }
    }
}
</script>
